/*
    Use this file to overwrite or add new translations to amcharts4
    Just add the key value pairs of the text you need to translate to the objects below.

    NOTE: The following files need to be loaded:
        /wp-content/themes/parent-build/amcharts4/lang/en.js
        /wp-content/themes/parent-build/amcharts4/lang/fr_FR.js

    They can be added through the WordPress admin by editing a Chart and adding the paths to the resources section.
 */

/* global am4lang_en, am4lang_fr_FR */

/* eslint-disable camelcase */

// Add or overwrite English translations if the locale is loaded
if (typeof am4lang_en !== 'undefined') {
    Object.assign(
        am4lang_en,
        {
            // Exporter
            "Save image ...": "",
            "Download all ...": "",
            "Download date range ...": "",
            "Annotate": "Annotate ...",
            "BoC_Chart": ""
        }
    );
}

// Add or overwrite French translations if the locale is loaded
if (typeof am4lang_fr_FR !== 'undefined') {
    Object.assign(
        am4lang_fr_FR,
        {
            // Exporter
            "Save image ...": "Sauvegarder l’image ...",
            "Download all ...": "Tout télécharger ...",
            "Download date range ...": "Télécharger la période ...",
            "Annotate ...": "Annoter ...",
            "BoC_Chart": "BdC_Graphique",

            // Month names
            "January": "janvier",
            "February": "février",
            "March": "mars",
            "April": "avril",
            "May": "mai",
            "June": "juin",
            "July": "juillet",
            "August": "août",
            "September": "septembre",
            "October": "octobre",
            "November": "novembre",
            "December": "décembre",

            // Short month names
            "Jan": "janv.",
            "Feb": "févr.",
            "Mar": "mars",
            "Apr": "avr.",
            "May(short)": "mai",
            "Jun": "juin",
            "Jul": "juill.",
            "Aug": "août",
            "Sep": "sept.",
            "Oct": "oct.",
            "Nov": "nov.",
            "Dec": "déc.",

            // Day names
            "Sunday": "Dimanche",
            "Monday": "Lundi",
            "Tuesday": "Mardi",
            "Wednesday": "Mercredi",
            "Thursday": "Jeudi",
            "Friday": "Vendredi",
            "Saturday": "Samedi",

            // Short day names
            "Sun": "Dim.",
            "Mon": "Lun.",
            "Tue": "Mar.",
            "Wed": "Mer.",
            "Thu": "Jeu.",
            "Fri": "Ven.",
            "Sat": "Sam.",

            // Zoom out text
            "Zoom Out": "Afficher tout"
        }
    );
}
